import { Box, Input, makeStyles } from '@material-ui/core';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import Edit from 'src/components/Icon/Edit';
import Check from 'src/components/Icon/Check';
import { editTracking } from 'src/store/modules/trackings';

const useStyles = makeStyles(() => ({
  tracking: {
    minWidth: '14rem',
    maxWidth: '14rem',
    minHeight: '2rem',
    maxHeight: '2rem',
    display: 'flex',
    alignItems: 'center'
  },

  input: {
    // minWidth: '9rem',
    maxWidth: '12rem',
    minHeight: '2rem',
    maxHeight: '2rem'
  },
  edit: {
    minWidth: '13rem',
    maxWidth: '13rem',
    minHeight: '2rem',
    maxHeight: '2rem',
    padding: '0.5rem 0.62rem',

    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    border: '1px solid #4778FF',
    background: '#fff'
  },
  editIcon: {
    minWidth: 16,
    maxWidth: 16,
    minHeight: 16,
    maxHeight: 16
  },

  line: {
    width: '100%',
    maxHeight: 1,
    border: '1px dashed #4778FF'
  }
}));

const TrackingEdit = ({ value, type, idx = -1 }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const inputRef = useRef(null);
  const [text, setText] = useState(value);
  const [focus, setFocus] = useState(false);

  var currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  var tracking = useSelector((state: RootState) => state.trackings.tracking);

  const [key, setKey] = useState(false);

  const handleChangeText = e => {
    e.preventDefault();
    let newTracking = {};
    if (idx === -1) {
      let newTrackings = tracking?.[type]?.slice();
      if (typeof text === 'string') {
        newTrackings.splice(currentIndex, 1, text.split('\n').join('\\n'));
      }
      newTracking = JSON.parse(
        `{"${type}": [${newTrackings?.map((_: any, idx: number) => {
          const newT = newTrackings?.[idx];
          return `"${newT}"`;
        })}]}`
      );
    } else {
      let newTrackingJson = tracking?.[type]?.slice();
      let newTrackingArray = tracking?.[type]?.[currentIndex]?.slice();
      if (typeof text === 'string') {
        newTrackingArray.splice(idx, 1, text.split('\n').join('\\n'));
      }
      newTrackingJson.splice(currentIndex, 1, newTrackingArray);
      newTracking = JSON.parse(
        `{"${type}": [${newTrackingJson?.map((trackings: any, idx: number) => {
          return `[${trackings?.map((tracking: any, idx2: number) => {
            return `"${tracking}"`;
          })}]`;
        })}]}`
      );
    }
    dispatch(editTracking({ ...tracking, ...newTracking }));
  };
  const handleClickEdit = () => {
    setFocus(true);
    inputRef.current.focus();
  };

  const handleChange = e => {
    const textSplit = e.target.value.split('');
    if (e.target.value.length > 20) return;
    if (textSplit[textSplit.length - 1] === "'") return;
    if (textSplit[textSplit.length - 1] === '"') return;

    setText(e.target.value);
  };
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      setKey(true);
      setFocus(false);
      handleChangeText(e);
      inputRef.current.blur();
    }
  };
  useEffect(() => {
    setText(value);
  }, [value]);

  return (
    <Box className={classes.tracking}>
      <Box className={classes.edit}>
        <Input
          ref={inputRef}
          className={classes.input}
          value={text}
          color="primary"
          onClick={() => {
            setFocus(true);
          }}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onBlur={e => {
            if (focus) {
              handleChangeText(e);
              setFocus(false);
              setText(value);
              setKey(true);
            }
          }}
          disableUnderline
        />
        <div
          tabIndex={0}
          className={classes.editIcon}
          onClick={
            e => (focus ? handleChangeText(e) : handleClickEdit())
            //   () => {
            //   console.log('test ' + focus);
            //   if (focus) handleChangeText();
            //   else handleClickEdit();
            // }
          }
        >
          {focus ? <Check /> : <Edit />}
        </div>
      </Box>
      <Box className={classes.line} />
    </Box>
  );
};

export default TrackingEdit;
